// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Plan selection modal (Admin Registration) — layout matches zordigo.com/pricing.html */
.plan-select-overlay .MuiBackdrop-root {
  background-color: rgba(15, 23, 42, 0.5) !important;
}

.plan-select-modal {
  outline: none;
  width: min(1120px, calc(100vw - 24px));
  max-height: calc(100vh - 32px);
  margin: auto;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.2);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.plan-select-modal--disclaimer {
  width: min(480px, calc(100vw - 24px));
}

.plan-select-header {
  position: relative;
  text-align: center;
  padding: 22px 48px 16px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
  flex-shrink: 0;
}

.plan-select-close {
  position: absolute !important;
  top: 12px;
  right: 12px;
  color: #64748b !important;
}

.plan-select-heading {
  margin: 0;
  font-size: 2.25rem;
  font-weight: 900;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.plan-select-sub {
  margin: 6px auto 0;
  max-width: 420px;
  font-size: 0.88rem;
  color: #64748b;
  line-height: 1.45;
}

.plan-select-body {
  padding: 20px 22px 24px;
  overflow-y: auto;
  background: linear-gradient(180deg, #f0f9ff 0%, #f8fbff 100%);
}

.plan-select-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  align-items: stretch;
}

@media (max-width: 900px) {
  .plan-select-grid {
    grid-template-columns: 1fr;
  }
}

.pricing-plan-card {
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.pricing-plan-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
}

.pricing-plan-card--featured {
  box-shadow: 0 16px 40px rgba(7, 166, 239, 0.18);
  border: 1px solid rgba(7, 166, 239, 0.35);
}

.pricing-plan-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
}

.pricing-plan-tagline {
  margin: 4px 0 0;
  color: #475569;
  font-size: 0.95rem;
}

.pricing-plan-divider {
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 14px 0 0;
}

.pricing-plan-price {
  margin-top: 20px;
}

.pricing-plan-price-note {
  margin: 0 0 4px;
  color: #07a6ef;
  font-weight: 700;
  font-size: 1.05rem;
}

.pricing-plan-price-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.pricing-plan-price-main {
  font-size: 2.15rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.03em;
  line-height: 1.1;
}

.pricing-plan-price-sub {
  font-size: 1.05rem;
  color: #64748b;
}

.pricing-plan-features {
  list-style: none;
  margin: 22px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: #334155;
  flex: 1 1;
}

.pricing-plan-feature {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 0.95rem;
  line-height: 1.45;
}

.pricing-plan-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.pricing-plan-icon--yes {
  color: #16a34a;
}

.pricing-plan-icon--no {
  color: #dc2626;
}

.pricing-plan-mark {
  color: #07a6ef;
  font-weight: 600;
}

.pricing-plan-terms {
  margin-top: 28px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 18px 16px;
}

.pricing-plan-terms h4 {
  margin: 0 0 10px;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 600;
  color: #334155;
}

.pricing-plan-terms ul {
  list-style: none;
  margin: 0;
  padding: 0;
  color: #64748b;
  font-size: 0.8rem;
  line-height: 1.45;
}

.pricing-plan-terms li + li {
  margin-top: 6px;
}

.plan-select-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  background: #07a6ef !important;
  color: #fff !important;
  border-radius: 10px !important;
  padding: 10px 14px !important;
  box-shadow: none !important;
  margin-top: 20px !important;
}

.plan-select-btn:hover {
  background: #0596d8 !important;
}

.plan-disclaimer {
  max-width: 420px;
  margin: 0 auto;
}

.plan-disclaimer-intro {
  margin: 0 0 16px;
  text-align: center;
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.5;
}

.plan-disclaimer-actions {
  display: flex;
  gap: 10px;
  margin-top: 18px;
}

.plan-disclaimer-back,
.plan-disclaimer-proceed {
  flex: 1 1;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
}

.plan-disclaimer-back {
  background: #fff;
  border: 1px solid #cbd5e1;
  color: #334155;
}

.plan-disclaimer-back:hover {
  background: #f8fafc;
}

.plan-disclaimer-proceed {
  background: #07a6ef;
  border: 1px solid #07a6ef;
  color: #fff;
}

.plan-disclaimer-proceed:hover {
  background: #0596d8;
}

.plan-disclaimer-back:disabled,
.plan-disclaimer-proceed:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.plan-select-empty {
  text-align: center;
  color: #64748b;
  padding: 32px 12px;
}

/* Toast overrides used on login/registration */
.custom-toast.Toastify__toast,
.custom-toast {
  font-family: inherit !important;
  font-size: 0.95rem !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.14) !important;
  padding: 12px 14px !important;
  min-height: 48px !important;
  color: #0f172a !important;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  gap: 8px !important;
}

.custom-toast .Toastify__toast-body,
.custom-toast-body {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 10px !important;
}

.custom-toast .Toastify__toast-icon {
  flex-shrink: 0 !important;
  width: 20px !important;
  margin: 0 !important;
}

.custom-toast .Toastify__toast-body > div:last-child {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  line-height: 1.35 !important;
}

.custom-toast .Toastify__close-button {
  flex: 0 0 auto !important;
  align-self: center !important;
  margin: 0 0 0 4px !important;
  padding: 0 !important;
  opacity: 0.65 !important;
  width: 20px !important;
  height: 20px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: inherit !important;
}

.custom-toast .Toastify__close-button > svg {
  display: block !important;
  width: 14px !important;
  height: 14px !important;
}

.custom-toast .Toastify__progress-bar {
  height: 3px !important;
}

.custom-toast-success {
  background: #ecfdf5 !important;
  border: 1.5px solid #6ee7b7 !important;
  color: #065f46 !important;
}

.custom-toast-error {
  background: #fef2f2 !important;
  border: 1.5px solid #fca5a5 !important;
  color: #991b1b !important;
}

.custom-toast-info,
.custom-toast-warning,
.custom-toast-default {
  background: #fff !important;
  border: 1.5px solid #cbd5e1 !important;
  color: #0f172a !important;
}

.custom-toast-warning {
  background: #fffbeb !important;
  border-color: #fcd34d !important;
  color: #92400e !important;
}
`, "",{"version":3,"sources":["webpack://./src/Css/PlanSelectModal.css"],"names":[],"mappings":"AAAA,wFAAwF;AACxF;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8CAA8C;EAC9C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;EAC/C,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;;EAEE,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;EAC9B,yDAAyD;EACzD,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;;;EAGE,2BAA2B;EAC3B,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B","sourcesContent":["/* Plan selection modal (Admin Registration) — layout matches zordigo.com/pricing.html */\r\n.plan-select-overlay .MuiBackdrop-root {\r\n  background-color: rgba(15, 23, 42, 0.5) !important;\r\n}\r\n\r\n.plan-select-modal {\r\n  outline: none;\r\n  width: min(1120px, calc(100vw - 24px));\r\n  max-height: calc(100vh - 32px);\r\n  margin: auto;\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.2);\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.plan-select-modal--disclaimer {\r\n  width: min(480px, calc(100vw - 24px));\r\n}\r\n\r\n.plan-select-header {\r\n  position: relative;\r\n  text-align: center;\r\n  padding: 22px 48px 16px;\r\n  border-bottom: 1px solid #eef2f7;\r\n  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.plan-select-close {\r\n  position: absolute !important;\r\n  top: 12px;\r\n  right: 12px;\r\n  color: #64748b !important;\r\n}\r\n\r\n.plan-select-heading {\r\n  margin: 0;\r\n  font-size: 2.25rem;\r\n  font-weight: 900;\r\n  color: #0f172a;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.plan-select-sub {\r\n  margin: 6px auto 0;\r\n  max-width: 420px;\r\n  font-size: 0.88rem;\r\n  color: #64748b;\r\n  line-height: 1.45;\r\n}\r\n\r\n.plan-select-body {\r\n  padding: 20px 22px 24px;\r\n  overflow-y: auto;\r\n  background: linear-gradient(180deg, #f0f9ff 0%, #f8fbff 100%);\r\n}\r\n\r\n.plan-select-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 20px;\r\n  align-items: stretch;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .plan-select-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.pricing-plan-card {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  padding: 28px 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);\r\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\r\n}\r\n\r\n.pricing-plan-card:hover {\r\n  transform: translateY(-6px);\r\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);\r\n}\r\n\r\n.pricing-plan-card--featured {\r\n  box-shadow: 0 16px 40px rgba(7, 166, 239, 0.18);\r\n  border: 1px solid rgba(7, 166, 239, 0.35);\r\n}\r\n\r\n.pricing-plan-title {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n}\r\n\r\n.pricing-plan-tagline {\r\n  margin: 4px 0 0;\r\n  color: #475569;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.pricing-plan-divider {\r\n  border: none;\r\n  border-top: 1px solid #e2e8f0;\r\n  margin: 14px 0 0;\r\n}\r\n\r\n.pricing-plan-price {\r\n  margin-top: 20px;\r\n}\r\n\r\n.pricing-plan-price-note {\r\n  margin: 0 0 4px;\r\n  color: #07a6ef;\r\n  font-weight: 700;\r\n  font-size: 1.05rem;\r\n}\r\n\r\n.pricing-plan-price-row {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.pricing-plan-price-main {\r\n  font-size: 2.15rem;\r\n  font-weight: 800;\r\n  color: #0f172a;\r\n  letter-spacing: -0.03em;\r\n  line-height: 1.1;\r\n}\r\n\r\n.pricing-plan-price-sub {\r\n  font-size: 1.05rem;\r\n  color: #64748b;\r\n}\r\n\r\n.pricing-plan-features {\r\n  list-style: none;\r\n  margin: 22px 0 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  color: #334155;\r\n  flex: 1;\r\n}\r\n\r\n.pricing-plan-feature {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 0.95rem;\r\n  line-height: 1.45;\r\n}\r\n\r\n.pricing-plan-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.pricing-plan-icon--yes {\r\n  color: #16a34a;\r\n}\r\n\r\n.pricing-plan-icon--no {\r\n  color: #dc2626;\r\n}\r\n\r\n.pricing-plan-mark {\r\n  color: #07a6ef;\r\n  font-weight: 600;\r\n}\r\n\r\n.pricing-plan-terms {\r\n  margin-top: 28px;\r\n  background: #f8fafc;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 18px 16px;\r\n}\r\n\r\n.pricing-plan-terms h4 {\r\n  margin: 0 0 10px;\r\n  text-align: center;\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  color: #334155;\r\n}\r\n\r\n.pricing-plan-terms ul {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  color: #64748b;\r\n  font-size: 0.8rem;\r\n  line-height: 1.45;\r\n}\r\n\r\n.pricing-plan-terms li + li {\r\n  margin-top: 6px;\r\n}\r\n\r\n.plan-select-btn {\r\n  text-transform: none !important;\r\n  font-weight: 600 !important;\r\n  background: #07a6ef !important;\r\n  color: #fff !important;\r\n  border-radius: 10px !important;\r\n  padding: 10px 14px !important;\r\n  box-shadow: none !important;\r\n  margin-top: 20px !important;\r\n}\r\n\r\n.plan-select-btn:hover {\r\n  background: #0596d8 !important;\r\n}\r\n\r\n.plan-disclaimer {\r\n  max-width: 420px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.plan-disclaimer-intro {\r\n  margin: 0 0 16px;\r\n  text-align: center;\r\n  color: #475569;\r\n  font-size: 0.95rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.plan-disclaimer-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 18px;\r\n}\r\n\r\n.plan-disclaimer-back,\r\n.plan-disclaimer-proceed {\r\n  flex: 1;\r\n  border-radius: 10px;\r\n  padding: 10px 14px;\r\n  font-weight: 600;\r\n  font-size: 0.95rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.plan-disclaimer-back {\r\n  background: #fff;\r\n  border: 1px solid #cbd5e1;\r\n  color: #334155;\r\n}\r\n\r\n.plan-disclaimer-back:hover {\r\n  background: #f8fafc;\r\n}\r\n\r\n.plan-disclaimer-proceed {\r\n  background: #07a6ef;\r\n  border: 1px solid #07a6ef;\r\n  color: #fff;\r\n}\r\n\r\n.plan-disclaimer-proceed:hover {\r\n  background: #0596d8;\r\n}\r\n\r\n.plan-disclaimer-back:disabled,\r\n.plan-disclaimer-proceed:disabled {\r\n  opacity: 0.65;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.plan-select-empty {\r\n  text-align: center;\r\n  color: #64748b;\r\n  padding: 32px 12px;\r\n}\r\n\r\n/* Toast overrides used on login/registration */\r\n.custom-toast.Toastify__toast,\r\n.custom-toast {\r\n  font-family: inherit !important;\r\n  font-size: 0.95rem !important;\r\n  border-radius: 12px !important;\r\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.14) !important;\r\n  padding: 12px 14px !important;\r\n  min-height: 48px !important;\r\n  color: #0f172a !important;\r\n  display: flex !important;\r\n  flex-direction: row !important;\r\n  flex-wrap: nowrap !important;\r\n  align-items: center !important;\r\n  gap: 8px !important;\r\n}\r\n\r\n.custom-toast .Toastify__toast-body,\r\n.custom-toast-body {\r\n  flex: 1 1 auto !important;\r\n  min-width: 0 !important;\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  display: flex !important;\r\n  flex-direction: row !important;\r\n  align-items: center !important;\r\n  gap: 10px !important;\r\n}\r\n\r\n.custom-toast .Toastify__toast-icon {\r\n  flex-shrink: 0 !important;\r\n  width: 20px !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n.custom-toast .Toastify__toast-body > div:last-child {\r\n  flex: 1 1 auto !important;\r\n  min-width: 0 !important;\r\n  line-height: 1.35 !important;\r\n}\r\n\r\n.custom-toast .Toastify__close-button {\r\n  flex: 0 0 auto !important;\r\n  align-self: center !important;\r\n  margin: 0 0 0 4px !important;\r\n  padding: 0 !important;\r\n  opacity: 0.65 !important;\r\n  width: 20px !important;\r\n  height: 20px !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  color: inherit !important;\r\n}\r\n\r\n.custom-toast .Toastify__close-button > svg {\r\n  display: block !important;\r\n  width: 14px !important;\r\n  height: 14px !important;\r\n}\r\n\r\n.custom-toast .Toastify__progress-bar {\r\n  height: 3px !important;\r\n}\r\n\r\n.custom-toast-success {\r\n  background: #ecfdf5 !important;\r\n  border: 1.5px solid #6ee7b7 !important;\r\n  color: #065f46 !important;\r\n}\r\n\r\n.custom-toast-error {\r\n  background: #fef2f2 !important;\r\n  border: 1.5px solid #fca5a5 !important;\r\n  color: #991b1b !important;\r\n}\r\n\r\n.custom-toast-info,\r\n.custom-toast-warning,\r\n.custom-toast-default {\r\n  background: #fff !important;\r\n  border: 1.5px solid #cbd5e1 !important;\r\n  color: #0f172a !important;\r\n}\r\n\r\n.custom-toast-warning {\r\n  background: #fffbeb !important;\r\n  border-color: #fcd34d !important;\r\n  color: #92400e !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
